import { render, staticRenderFns } from "./CostStats.container.vue?vue&type=template&id=ca65a50e&scoped=true&"
import script from "./CostStats.container.vue?vue&type=script&lang=js&"
export * from "./CostStats.container.vue?vue&type=script&lang=js&"
import style0 from "./CostStats.container.vue?vue&type=style&index=0&id=ca65a50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca65a50e",
  null
  
)

export default component.exports